import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { OrcStatus } from '../models/orc-status';

@Injectable({
  providedIn: 'root'
})
export class OrcStatusService {

  constructor(private http: HttpClient) {

  }

  consultar(tipo) {
    return this.http.get<OrcStatus[]>(globals.apiUrl + '/api/OrcStatus/Lista',
      { params: new HttpParams().set('tipo', tipo) });
  }

  consultarPorId(id) {
    return this.http.get<any>(globals.apiUrl + '/api/OrcStatus/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(orcStatus: OrcStatus) {
    return this.http.post(globals.apiUrl + '/api/OrcStatus/Salvar', orcStatus,
      { responseType: 'text' });
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/OrcStatus/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
